konnyScript(function($){


  var clipboard = new ClipboardJS('#copy_text');
  
  clipboard.on('success', function(e) {
    console.info('Text:', e.text);
    alert("Link copied. Share on your social media.");
  });
  
  clipboard.on('error', function(e) {
    alert("Link copied. Share on your social media.");
  });

  
  var clipboard01 = new ClipboardJS('#copy_bw_text01'); 
   
  clipboard01.on('success', function(e) {
    console.info('Text:', e.text);
    alert("Code copied. Add the item to your cart.");
  });
  
  clipboard01.on('error', function(e) {
    alert("Code copied. Add the item to your cart.");
  });


  
  var clipboard02 = new ClipboardJS('#copy_bw_text02'); 
   
  clipboard02.on('success', function(e) {
    console.info('Text:', e.text);
    alert("Code copied. Add the item to your cart.");
  });
  
  clipboard02.on('error', function(e) {
    alert("Code copied. Add the item to your cart.");
  });

  
});

